<a [routerLink]="[]" fragment="main" class="skiplink" translate>
    App.skip_to_main
</a>
<div *ngIf="!isProduction" id="env" class="{{env}}">{{env}}-omgeving</div>
<div class="app-container container" [ngClass]="themeClass" [hidden]="!hasChild">
    <dmv-pub-header class="row header" [displayServiceUnavailable]="bannerTekst$ | async"
        [displayServiceUnavailableTekst]="bannerTekst$ | async"></dmv-pub-header>
    <main id="main" tabindex="-1">
        <router-outlet (activate)="hasChild = true"></router-outlet>
        <dmv-pub-sub-footer *ngIf="showSubfooter$ | async"></dmv-pub-sub-footer>
    </main>
    <footer class="mt-40">
        <dmv-pub-footer></dmv-pub-footer>
    </footer>
    <div *ngIf="message$ | async; let message" class="visually-hidden" role="status" aria-live="polite"
        aria-atomic="true" [innerText]="message.text">
    </div>
</div>